<template>
    <div class="register-info">
        <div class="register-info-center">
            <div class="register-info-title">{{ $t('m.registerTitle') }}</div>
            <div class="r-i-name-group" v-if="needName">
                <input class="r-i-input" type="text" maxlength="50" :placeholder="$t('m.fNameInput')" v-model="formData.first_name" @input="validateInput">
                <input class="r-i-input" type="text" maxlength="50" :placeholder="$t('m.lNameInput')" v-model="formData.last_name" @input="validateInput">
            </div>

            <input v-if="needEmail" class="r-i-input" type="email" maxlength="254" :placeholder="$t('m.emailInput')" v-model="formData.email" @input="validateInput">

            <div v-if="needDob" v-active-touch class="r-i-birthday-c r-i-input interactive-surface" @click="clickBirthInput">
                <span v-if="!showBirthInput" class="birth-placeholder">{{ $t('m.birthInput') }}</span>
                <form-date ref="birthInput" v-show="showBirthInput" v-model="birthdayStr" @input="validateInput"/>
            </div>

            <input v-if="needPc" class="r-i-input" type="text" maxlength="20" :placeholder="$t('m.postCodeInput')" v-model="formData.postCode" @input="validateInput">

            <span v-active-touch @click="submitInfo" class="primary-btn register-info-btn" :class="!valid ? 'invalid' : ''">{{ $t('next') }}</span>
        </div>
        <LanguageSelector/>
    </div>
</template>

<script>
import {editProfile} from "../../api/logined";
import FormDate from '../../components/forms/FormDate'
import LanguageSelector from '../../components/LanguageSelector';
import {date2Time} from "../../utils/tool";
import { consumePostLoginRedirect } from "@/utils/postLoginRedirect";

export default {
    name: "RegisterInfo",
    components: {FormDate, LanguageSelector},
    data() {
        return {
            formData: {
                first_name: undefined,
                last_name: undefined,
                email: undefined,
                birthday: undefined,
                postCode: undefined,
            },
            birthdayStr: undefined,
            showBirthInput: false,
            valid: false,
        };
    },
    computed: {
        needName() {
            return this.$store.getters.user_info_collection.includes('name')
        },
        needEmail() {
            return this.$store.getters.user_info_collection.includes('email')
        },
        needDob() {
            return this.$store.getters.user_info_collection.includes('dob')
        },
        needPc() {
            return this.$store.getters.user_info_collection.includes('pc')
        }
    },
    methods: {
        // 校验表单信息
        validateInput() {
            this.valid = true; // 默认设置为有效

            if (this.needName && (!this.formData.first_name || !this.formData.last_name)) {
                this.valid = false;
            }
            if (this.needEmail) {
                if (!this.formData.email) {
                    this.valid = false;
                } else if (!/[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+/.test(this.formData.email)) {
                    this.valid = false;
                }
            }
            if (this.needDob) {
                if (!this.birthdayStr) {
                    this.valid = false;
                } else {
                    let bDate = this.birthdayStr.split('-');
                    if (bDate.length < 3 || bDate[0] < 1800 || bDate[0] > 2200 || bDate[1] < 1 || bDate[1] > 12 || bDate[2] < 1 || bDate[2] > 31) {
                        this.valid = false;
                    } else {
                        // 转化为时间戳
                        this.formData.birthday = date2Time(this.birthdayStr);
                    }
                }
            }
        },
        // 提交用户信息
        submitInfo() {
            this.validateInput(); // 在提交时再做最终校验

            if (!this.valid) {
                // 在 submitForm 中做完整的验证和提示
                if (this.needName && (!this.formData.first_name || !this.formData.last_name)) {
                    this.toast(this.$t('tMsg.inputAll'));
                }
                if (this.needEmail) {
                    if (!this.formData.email) {
                    this.toast(this.$t('tMsg.inputAll'));
                    } else if (!/[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+/.test(this.formData.email)) {
                    this.toast(this.$t('tMsg.wrongEmail'));
                    }
                }
                if (this.needDob) {
                    if (!this.birthdayStr) {
                        this.toast(this.$t('tMsg.inputAll'));
                    } else {
                        let bDate = this.birthdayStr.split('-');
                        if (bDate.length < 3 || bDate[0] < 1800 || bDate[0] > 2200 || bDate[1] < 1 || bDate[1] > 12 || bDate[2] < 1 || bDate[2] > 31) {
                            this.toast(this.$t('tMsg.wrongBirthday'));
                        }
                    }
                }
                if (this.needPc) {
                    if (!this.formData.postCode) {
                        this.valid = false;
                    }
                }

                if (!this.valid) {
                    return;
                }
            }

            this.showLoading()
            editProfile(this.formData).then(r => {
                this.$store.dispatch('setUserInfoCollection', [])
                this.$router.push(consumePostLoginRedirect() || {path: '/'})
            }).catch(er => {
                this.toast(er.message)
            }).finally(_ => {
                this.hideLoading()
            });
        },
        
        clickBirthInput() {
            if (this.showBirthInput) { return }
            this.showBirthInput = true
            this.$refs.birthInput.startInput()
        }
    }
}
</script>

<style lang="scss">
.register-info-center {
    padding: 44px 40px 0;
}

.register-info-title {
    margin-top: 34px;
    margin-bottom: 38px;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    text-align: center;

}

.r-i-input {
    padding: 0;
    border: none;
    width: 100%;
    outline: none;
    border-radius: 5px;
    color: #333;
    line-height: 46px;
    padding: 0 15px;
    height: 46px;
    margin: 5px 0;
    border: 1px solid #E6E6E6;
    font-size: 14px;

    &::placeholder {
        color: #C6C6C6;
        font-family: SF Pro Text;
        font-size: 14px;
    }
}

.r-i-name-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 10px;
}

.FormDate__input {
    background: transparent;
}

.FormDate {
    margin-left: -16px;
    height: 44px;
}

.FormDate__input {
    font-size: 14px;
    color: #333;
    &::placeholder {
        color: #C6C6C6;
    }
}

.FormDate__divider {
    padding: 0;
}

.birth-placeholder {
    color: #C6C6C6;
    height: 34px;
    line-height: 34px;
}

.register-info-btn {
    margin-top: 25px !important;

    &.invalid {
        background: #E3E3E3;
        color: #A9A9A9;
    }
}

// 修改浏览器自动填充电话号码后的高亮样式
input:-webkit-autofill {
    font-family: 'SF Pro Text';
    font-weight: 400;
    box-shadow: 0 0 0 0 #fff inset !important; /* 修改背景颜色 */
    -webkit-box-shadow: 0 0 0 30px #fff inset !important; /* 修改背景颜色 */
    -webkit-text-fill-color: #333333 !important; /* 修改文本颜色 */
}

</style>
